// import { getCoreBlocks } from './core.js';

const gap = '<sep gap="36"/>';


const bayToolbox = function () {
  return `
  <category
    name="Bay"
    id="p3g_bay"
    colour="#088FF1"
    secondaryColour="#0678C8">

      <block type="p3g_bay_moveTo">
      </block>

      <block type="p3g_bay_moveSpaces">
        <value name="NUM">
          <shadow type="math_number">
            <field name="NUM">1</field>
          </shadow>
        </value>
      </block>

      <block type="p3g_bay_turnLeft">
      </block>
      <block type="p3g_bay_turnRight">
      </block>
      <block type="p3g_bay_pickUp">
      </block>
      <block type="p3g_bay_drop">
      </block>
  </category>
  `
}

const makeP3GBayToolboxXML = () => {
  const xmlOpen = '<xml style="display: none">';
  const xmlClose = "</xml>";
  // const coreCategories = getCoreBlocks();
  return [
    xmlOpen,
    gap,
    bayToolbox(),
    xmlClose
  ].join("\n");
}

export { makeP3GBayToolboxXML, bayToolbox };